import { createAction, props } from '@ngrx/store';
import { DossierAttachment } from './dossier-attachment.model';

// fetch 
export const fetchDossierAttachmentListData = createAction('[Data] fetch club user list');
export const fetchDossierAttachmentListSuccess = createAction('[Data] fetch club user list success', props<{ DossierAttachmentListdata: DossierAttachment[] }>())
export const fetchDossierAttachmentListFail = createAction('[Data fetch club user list failed]', props<{ error: string }>())

// fetch all
export const fetchRecords = createAction(
    '[Data] fetch records dossier attachment',
    props<{ dossierId: string }>()
);
export const fetchRecordsSuccess = createAction(
    '[Data] fetch records dossier attachment success', 
    props<{ listData: DossierAttachment[], total: number }>()
);
export const fetchRecordsFail = createAction(
    '[Data] fetch records dossier attachment failure', 
    props<{ error: string }>()
);


// Delete Data
export const deleteRecord = createAction(
    '[Data] Delete record dossier attachment',
    props<{ dossierId: string, id: string }>()
);
export const deleteRecordSuccess = createAction(
    '[Data] Delete record dossier attachment success'
);
export const deleteRecordFailure = createAction(
    '[Data] Delete record dossier attachment failure',
    props<{ error: string }>()
);

//Reset State
export const resetState = createAction(
    '[Data] reset state dossier attachment',
);